import Style from "./CorporateHomeTestimonials.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper";
import { Container } from "react-bootstrap";
import Assets from "../Layouts/Assets";
import { useTranslation } from "react-i18next";
import { useHome } from "../../Logic/useHome";
import moment from "moment";
import { useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

const CorporateHomeTestimonials = () => {
  const { t } = useTranslation();

  const { testimonials } = useHome();
  // const { testimonials, testimonialData } = useHome();

  let testimonialData = [
    {
      id: 1,
      image: Assets.testimonial_img_01,
      name: 'Adwin diclose',
      description: 'Without realizing it, by uploading to Family photo album, i was making real and meaningful connections all over the world.',
      date: '2022-09-07 00:00:00',
      created_at: '2022-09-06T06:58:50.000000Z',
      updated_at: '2022-12-15T09:05:12.000000Z',
      thumbnail: 'thumbnail20221215143510nnECy.jpg',
      medium_thumbnail: Assets.testimonial_img_01,
      large_thumbnail: Assets.testimonial_img_01,
      country_based_testimonial: []
    },
    {
      id: 2,
      image: Assets.testimonial_img_02,
      name: 'Chris Gayle',
      description: 'A wealth of information. I have been having a difficult time locating information about my ancestry. I found what i needed at this site.',
      date: '2022-09-08 00:00:00',
      created_at: '2022-09-06T06:59:53.000000Z',
      updated_at: '2022-12-15T09:04:22.000000Z',
      thumbnail: 'thumbnail202212151434225oo0x.jpeg',
      medium_thumbnail: Assets.testimonial_img_02,
      large_thumbnail: Assets.testimonial_img_02,
      country_based_testimonial: []
    },
    {
      id: 3,
      image: Assets.testimonial_img_03,
      name: 'Chris Morris',
      description: 'At first, i wasn\'t sure whether any of my photos were good enough in comparison to the photos i saw on the site, but i uploaded a few anyway.',
      date: '2022-09-09 00:00:00',
      created_at: '2022-09-06T07:01:17.000000Z',
      updated_at: '2022-12-15T08:57:44.000000Z',
      thumbnail: 'thumbnail20221215142743pBOiD.jpg',
      medium_thumbnail: Assets.testimonial_img_03,
      large_thumbnail: Assets.testimonial_img_03,
      country_based_testimonial: []
    }
  ]

  useEffect(() => {
    testimonials();
  }, []);

  return (
    <div className={Style.home_testimonials}>
      <div className={Style.anim_elements}>
        <figure
          className={`${Style.anim_elem} ${Style.donut_blue} anim_element anim`}
        >
          <img src={Assets.testimonial_donut_blue} alt="donut_blue" />
        </figure>
      </div>
      <Container>
        <div className={Style.home_testimonials_wrap}>
          <div
            className={`${
              Style.home_testimonials_title
            } ${"section_title_block center"}`}
          >
            <h2 className="anim load-anim">{t("testimonial_title_1")}</h2>
            <p className="anim load-anim">{t("testimonial_title_2")}</p>
          </div>
          <div className={Style.home_testimonials_cardslider}>
            <Swiper
              slidesPerView={1}
              spaceBetween={30}
              loop={true}
              navigation={{
                prevEl: ".swiper-navigation-prev",
                nextEl: ".swiper-navigation-next",
              }}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
              }}
              modules={[Autoplay, Pagination, Navigation]}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              speed={1200}
              className={`${Style.home_testimonials_swiper} anim load-anim`}
            >
              {testimonialData
                ? testimonialData.map((item, index) => {
                   
                    return (
                      <SwiperSlide key={item.id}>
                        <div
                          className={Style.home_testimonials_testimonialcard}
                        >
                          <figure className={Style.testimonial_image}>
                            <LazyLoadImage
                              className={Style.home_testimonials_cardimg}
                              src={
                                item.large_thumbnail ? item.large_thumbnail : ""
                              }
                              alt={`testimony_image`}
                            />
                          </figure>
                          <div className={Style.testimonial_content}>
                            <p className={Style.home_testimonials_cardtext}>
                              {item.description}
                            </p>
                            <div className={Style.home_tastimonials_data}>
                              <p className={Style.home_testimonials_author}>
                                {item.name}
                              </p>
                              <p className={Style.home_testimonials_date}>
                                {moment(item.date).format("MMMM D, YYYY")}
                              </p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    );
                  })
                : [1, 2, 3].map((item, index) => {
                    return (
                      <SwiperSlide>
                        <div
                          className={`${Style.home_testimonials_testimonialcard} data-loading`}
                          key={index}
                        >
                          <figure className={Style.testimonial_image}></figure>
                          <div className={Style.testimonial_content}>
                            <p className={Style.home_testimonials_cardtext}>
                              <span className={Style.lines}></span>
                              <span className={Style.lines}></span>
                              <span className={Style.lines}></span>
                            </p>
                            <div className={Style.home_tastimonials_data}>
                              <p className={Style.home_testimonials_author}></p>
                              <p className={Style.home_testimonials_date}></p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    );
                  })}
            </Swiper>
            <button className="swiper-navigation-prev swiper-button-prev swiper-navigation-button anim load-anim"></button>
            <button className="swiper-navigation-next swiper-button-next swiper-navigation-button anim load-anim"></button>
          </div>
        </div>
      </Container>
    </div>
  );
};




export default CorporateHomeTestimonials;
